import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ReplaySubject, map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class PermissionsService {
    private userPersmissions: string[] = [];
    private userPermissions$: ReplaySubject<any> = new ReplaySubject<any>();
    private isUserAdmin: boolean = false;

    private authBasePath = environment.interop.authCore.basePath;
    private getUserPermissionsAuthLibUrl = this.authBasePath + environment.interop.authCore.platform.getUserPermissionsAuthLib;

    private clientId = environment.interop.clientId;
    private moduleId = environment.interop.moduleId;

    constructor(private http: HttpClient) { }

    private fetchUserPermission(clientId: number, moduleId: number) {
        return this.http
            .get(this.getUserPermissionsAuthLibUrl + clientId + '/' + moduleId)
            .pipe(
                map(
                    (res: any) =>
                        (Object.values(res.data)[0] as any).permissions
                )
            );
    }

    storeUserPermissions() {
        return this.fetchUserPermission(this.clientId, this.moduleId)
            .subscribe({
                next: (data: any) => {
                    this.userPersmissions = data;
                    this.userPermissions$.next(true);
                },
                error: (err: any) => {
                    console.log(err);
                },
            });
    }

    getUserPermissions() {
        return this.userPersmissions;
    }

    getUserPermissions$() {
        return this.userPermissions$;
    }

    hasPermission(targetPermissions: string): boolean {
        const hasPerm = this.userPersmissions.some((permissions) =>
            permissions.includes(targetPermissions)
        );
        return hasPerm;
    }
}
